import React from 'react';
import GuideModal from '../../components/molecule/Modals/GuideModal';
import * as GuideText from './guideText';
import styled from 'styled-components';

const GuideModalStyled = styled(GuideModal)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 95%;
  max-width: 800px;
  height: auto;
  padding-bottom: 40px;
  padding-top: 20px;
`

export const dashboardGuide = [
  {
    text: 'Dashboard Help',
    onClick: () => <GuideModalStyled open={true} header="Dashboard Help" guideText={GuideText.Dashboard} enableFeedback={true} />,
    icon: 'chrome_reader_mode'
  }
]

export const exerciseGuide = [
  {
    text: 'Exercise Library Help',
    onClick: () => <GuideModalStyled open={true} header="Exercise Library Help" guideText={GuideText.Exercise} enableFeedback={true} faq={GuideText.ExerciseFAQ} />,
    icon: 'chrome_reader_mode'
  }
]

export const exerciseDemosGuide = [
  {
    text: 'Unlabeled Exercise Demo Help',
    onClick: () => <GuideModalStyled open={true} header="Unlabeled Exercise Demo Help" guideText={GuideText.ExerciseDemo} guideTextList={GuideText.ExerciseDemoTextList} enableFeedback={true} faq={GuideText.ExerciseDemoFAQ} />,
    icon: 'chrome_reader_mode'
  }
]

export const channelGuide = [
  {
    text: 'Channel Help',
    onClick: () => <GuideModalStyled open={true} header="Channel Help" guideText={GuideText.Channel} enableFeedback={true} faq={GuideText.ChannelFAQ} />,
    icon: 'chrome_reader_mode'
  }
]

export const classGuide = [
  {
    text: 'Class Library Help',
    onClick: () => <GuideModalStyled open={true} header="Class Library Help" guideText={GuideText.Class} enableFeedback={true} faq={GuideText.ClassFAQ} />,
    icon: 'chrome_reader_mode'
  }
]

export const classDraftsGuide = [
  {
    text: 'Unpublished Class Help',
    onClick: () => <GuideModalStyled open={true} header="Unpublished Class Help" guideText={GuideText.ClassDrafts} enableFeedback={true} />,
    icon: 'chrome_reader_mode'
  }
]

export const playbookGuide = [
  {
    text: 'Playbook Help',
    onClick: () => <GuideModalStyled open={true} header="Playbook Help" guideTextList={GuideText.PlaybookTextList} enableFeedback={true} faq={GuideText.PlaybookFAQ} />,
    icon: 'chrome_reader_mode'
  }
]

export const templateGuide = [
  {
    text: 'Template Help',
    onClick: () => <GuideModalStyled open={true} header="Template Help" guideTextList={GuideText.TemplateTextList} enableFeedback={true} />,
    icon: 'chrome_reader_mode'
  }
]
